import {Navigate} from "react-router-dom";

import {useStoredMe} from "../store/me";

export default function SupportGuard({children}: {children: React.ReactNode}) {
  const me = useStoredMe();

  if (me?.impersonation) {
    return <Navigate to="/home" replace />;
  }

  if (!me?.isAdmin && !me?.isSuperAdmin) {
    return <Navigate to="/home" replace />;
  }

  return <>{children}</>;
}
